// extracted by mini-css-extract-plugin
export default {"inlineFields":"inlineFields--oE8JO","mediaField":"mediaField--Dkq9H","mediaPreview":"mediaPreview--auTmc","ratingField":"ratingField--d7S8K","colorField":"colorField--vVWZj"};